const Loading = () => {
  return (
    <div className="flex size-full items-center justify-center dark:text-grey-500">
      Loading
    </div>
  );
};

export default Loading;
